import { CSSProperties } from '@material-ui/styles';
import classNames from 'classnames';
import useStyles from '../../assets/jss/material-dashboard-pro-react/components/cardStyleTS';
import React from 'react';

type Color = 'primary'
	| 'info'
	| 'success'
	| 'warning'
	| 'danger'
	| 'rose';

type CardProps = {
	className?: string;
	plain?: boolean;
	profile?: boolean;
	blog?: boolean;
	raised?: boolean;
	background?: boolean;
	pricing?: boolean;
	testimonial?: boolean;
	color?: Color;
	product?: boolean;
	chart?: boolean;
	login?: boolean;
	children?: any;
	style?: CSSProperties;
};

export default function Card(props: CardProps) {
	const classes = useStyles();

	const {
		className,
		children,
		plain,
		profile,
		blog,
		raised,
		background,
		pricing,
		color,
		product,
		testimonial,
		chart,
		login,
		style,
		...rest
	} = props;

	const cardClasses = classNames({
		[classes.card]: true,
		[classes.cardPlain]: plain,
		[classes.cardProfile]: profile || testimonial,
		[classes.cardBlog]: blog,
		[classes.cardRaised]: raised,
		[classes.cardBackground]: background,
		[classes.cardPricingColor]: (pricing && color !== undefined) || (pricing && background !== undefined),
		[classes[color]]: color,
		[classes.cardPricing]: pricing,
		[classes.cardProduct]: product,
		[classes.cardChart]: chart,
		[classes.cardLogin]: login,
		[className]: className !== undefined,
	});

	return (
		<div className={cardClasses} style={style} {...rest}>
			{children}
		</div>
	);
}
